/**
 * Structural directive that conditionally includes a template based on whether the current user is a developer.
 *
 * This directive checks the current user's type using the `UsersService`. If the user's `tipo` property is `"developer"`,
 * the template is rendered; otherwise, it is not included in the DOM.
 *
 * @example
 * <!-- Only visible to users with tipo === 'developer' -->
 * <div *isDeveloper>
 *   Developer-only content here.
 * </div>
 *
 * @see UsersService
 */
import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { UsersService } from "../services/users.service";

@Directive({
  selector: "[isDeveloper]",
})
export class IsDeveloperDirective implements OnInit {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private usersService: UsersService
  ) {}

  ngOnInit() {
    const isDeveloper = this.usersService.getCurrentUser().tipo === "developer";
    if (isDeveloper) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
